import { stores as IaAnnotationsStores } from './annotations';
import { ImageAnalysisStore } from './ImageAnalysisStore';
import { IaJobs } from './jobs';
import { MacroStore } from './macros/MacroStore';
import { ResultsStore } from './results/ResultsStore';
import { ResultStylesStore } from './results/ResultStylesStore';
import { ImageAnalysisLockdownService } from './ImageAnalysisLockdownService';

export * from './consts';

export const stores = [
  ImageAnalysisStore,
  ImageAnalysisLockdownService,
  IaJobs,
  MacroStore,
  ResultsStore,
  ResultStylesStore,
  ...IaAnnotationsStores
];



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/index.js